import Page from './page';

export default Page;



// WEBPACK FOOTER //
// ./src/structure/page/index.js